/* eslint-disable react-hooks/exhaustive-deps */

import { Grid, TableCell, TableRow } from "@material-ui/core"
import { ModalDeleteConfirm, TableAction } from "App/Component/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import { useDatatables } from "App/hooks"
import {
  defaultToastError,
  formatNumber,
  isNull,
  defaultToastSuccess,
  convertToValidPrice,
} from "App/utils/helpers"
import { FreezeTableClient } from "components/organism"
import React, { useContext, useEffect, useState } from "react"
import { DaftarJasa, getTotal, getTotalFilterID, Perhitungan } from ".."
import { FormContext } from "../../context/FormContext"
import {
  deleteJasaById,
  getJasaByPenjualanID,
  ModalDaftarJasa,
  RESET_STATE_DAFTAR_JASA,
} from "./DaftarJasa/helpers"

function TabJasa({
  perhitunganPenjualan,
  setPerhitunganPenjualan,

  setNewDataJasaByKelas,
  rowsJasaByKelas,

  loading,

  handleClickReset,

  totalDataJasaByKelas,

  formFilterJasaByKelas,
  setFormFilterJasaByKelas,
}) {
  const [rows, setRows] = useState()

  const { formData, setFormData } = useContext(FormContext)
  const [formJasa, setFormJasa] = useState(RESET_STATE_DAFTAR_JASA)

  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)
  const [showModalJasa, setShowModalJasa] = useState(false)

  const getJasaDijual = () => {
    if (isNull(formData.penjualan_id)) {
      const jasa = formData.jasa.filter(
        (e) =>
          e.kelas_id === formData.kelas_id &&
          e.asuransi_id === formData.asuransi_id,
      )
      setRows(jasa)
    }
  }

  const deleteJasaDijual = async () => {
    const filterJasa = rows.filter((e) => e.id !== formJasa.id)

    if (!isNull(formData.penjualan_id)) {
      const totalJasa = await getTotalFilterID(rows, formJasa.id, "jasa")

      const totalBarang = getTotal(formData.barang, "barang")
      const totalRikjang = getTotal(formData.rikjang, "rikjang")
      const totalFasilitas = getTotal(formData.fasilitas, "fasilitas")
      const totalPaket = getTotal(formData.paket, "paket")

      const jumlah =
        totalBarang + totalRikjang + totalJasa + totalFasilitas + totalPaket

      const potongan = formData.potongan
      const subTotal = jumlah - potongan
      const taxPercent = isNull(formData.tax_percent) ? 0 : formData.tax_percent
      const taxNumber = (taxPercent / 100) * subTotal
      const total = subTotal + taxNumber

      const form = {
        id: formJasa.id,
        penjualanId: formData.penjualan_id,
        harga_total_jasa: convertToValidPrice(totalJasa),
        total_penjualan: convertToValidPrice(jumlah),
        sisa: convertToValidPrice(total),

        tax: taxPercent,
        jumlah_tax: convertToValidPrice(taxNumber),
        discount: convertToValidPrice(formData.potongan / total),
        jumlah_set_discount: potongan,
      }
      const res = await deleteJasaById(form)
      if (res.state) {
        setShowModalDeleteConfirm(false)
        await setNewJasaDijual(filterJasa, false)
        defaultToastSuccess(res.message)
      } else {
        setShowModalDeleteConfirm(false)
        defaultToastError(res.message)
      }
    } else {
      setShowModalDeleteConfirm(false)
      await setNewJasaDijual(filterJasa, false)
      defaultToastSuccess("List jasa berhasil dihapus")
    }
  }

  const validPayload = (row) => {
    return {
      id: row.id,
      mh_jasa_id: row?.mhJasaId,
      namaJasa: row.namaJasa,
      jasa_id: row?.jasa_id,
      qty: row?.qty,
      keterangan: row.qty,
      harga: row.harga,
      hargabeli: row.hargabeli,
      hargaCustom: row.hargaCustom,
      hargaCustom2: formatNumber(row.hargaCustom),
      doctor_id: parseInt(row.doctor_id),
      doctor_name: row.doctor_name,
    }
  }

  function clickUpdate(row) {
    setShowModalJasa(!showModalJasa)
    const payload = validPayload(row)
    if (isNull(formData.penjualan_id)) {
      setFormJasa({
        ...payload,
        kelas_id: row.kelas_id,
        asuransi_id: row.asuransi_id,
        diskon: row.diskon,
      })
    } else {
      setFormJasa({
        ...payload,
        total: row.hargaCustom * parseInt(row.qty),
        gudang_id: formData.gudang_id,
        kelas_id: formData.kelas_id,
        asuransi_id: formData.asuransi_id,
        diskon: row.diskon,
      })
    }
    setShowModalJasa(!showModalJasa)
  }

  function clickDelete(row) {
    setFormJasa({
      ...formJasa,
      id: row?.id,
    })
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  useEffect(() => {
    ;(async () => {
      await setNewDataJasaByKelas()
      if (isNull(formData.penjualan_id)) {
        getJasaDijual()
      }
    })()
  }, [formData.kelas_id, formData.asuransi_id, formData.reload])

  const handleClickSelect = (row) => {
    if (!isNull(formData.kelas_id)) {
      setFormJasa({
        id: "",
        jasa_id: row.id_jasa,
        mh_jasa_id: row.id,
        qty: 1,
        keterangan: "-",
        harga: row.harga_jual,
        hargaCustom: row.harga_jual,
        hargabeli: row.harga_beli,
        hargaCustom2: formatNumber(row.harga_jual),
        kelas_id: formData.kelas_id,
        asuransi_id: formData.asuransi_id,
        namaJasa: row.namaMsJasa,
        doctor_id: formData.dokter_id,
        doctor_name: formData.dokter_name,
        diskon: formData.diskon?.diskon_jasa ?? 0,
      })
      setShowModalJasa(!showModalJasa)
    } else {
      defaultToastError("Kelas tidak boleh kosong!")
    }
  }

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: isNull(rows) ? [] : rows,
    orderByDefault: "namaJasa",
    orderByRow: ["namaJasa"],
  })

  const setNewJasaDijual = async (
    jasa = formData.jasa,
    is_jurnal = formData.is_jurnal,
  ) => {
    const reload = formData.reload_perhitungan || false
    if (isNull(formData.penjualan_id)) {
      setRows(jasa)
      setFormData({
        ...formData,
        jasa,
        is_jurnal,
        reload_perhitungan: !reload,
      })
    } else {
      const res = await getJasaByPenjualanID(formData.penjualan_id)

      if (res.state) {
        setRows(res.data)
        setFormData({
          ...formData,
          jasa: res.data,
          is_jurnal,
          reload_perhitungan: !reload,
        })
      }
    }
  }

  useEffect(() => {
    ;(async () => {
      if (!isNull(formData.penjualan_id)) {
        await setNewJasaDijual()
      }
    })()
  }, [
    formData.gudang_id,
    formData.kelas_id,
    formData.asuransi_id,
    formData.reload,
    formData.penjualan_id,
  ])

  let total = 0
  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteJasaDijual()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {showModalJasa && (
        <ModalDaftarJasa
          setShowModal={() => setShowModalJasa(false)}
          formJasa={formJasa}
          setFormJasa={setFormJasa}
          setNewJasaDijual={setNewJasaDijual}
          handleClickSelect={handleClickSelect}
          totalPenjualan={perhitunganPenjualan.jumlah}
          sisaPenjualan={perhitunganPenjualan.total}
          setNewDataJasaByKelas={setNewDataJasaByKelas}
        />
      )}
      <Grid container spacing={3}>
        <Grid item xs={6} sm={6}>
          <DaftarJasa
            formJasa={formJasa}
            setFormJasa={setFormJasa}
            rows={rowsJasaByKelas}
            handleClickSelect={handleClickSelect}
            setNewDataJasaByKelas={setNewDataJasaByKelas}
            totalData={totalDataJasaByKelas}
            formFilterJasaByKelas={formFilterJasaByKelas}
            setFormFilterJasaByKelas={setFormFilterJasaByKelas}
            loading={loading}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <Perhitungan
            perhitunganPenjualan={perhitunganPenjualan}
            setPerhitunganPenjualan={setPerhitunganPenjualan}
            handleClickReset={handleClickReset}
          />
        </Grid>
      </Grid>

      <div className="mt-1">
        <FreezeTableClient
          title="DAFTAR JASA YANG DIJUAL"
          setQ={setQ}
          withAddButton={false}
          withExportButton={false}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={rows}
          headCells={headCells}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
        >
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              const jumlahRaw = (row.hargaCustom - row.nilai_diskon) * row.qty
              const jumlah = jumlahRaw
              total += jumlah
              return (
                <TableRow hover key={index}>
                  <TableCell
                    scope="row"
                    padding="none"
                    width="5%"
                    align="center"
                  >
                    {index + 1}
                  </TableCell>

                  <TableCell
                    scope="row"
                    padding="none"
                    width="5%"
                    align="center"
                  >
                    {!formData.is_lock && !formData.is_close && (
                      <TableAction
                        clickDelete={() => clickDelete(row)}
                        clickUpdate={() => clickUpdate(row)}
                      />
                    )}
                  </TableCell>
                  <TableCell align="left">{row?.namaJasa}</TableCell>
                  <TableCell align="left">{row?.doctor_name}</TableCell>

                  <TableCell align="left" width={"5%"}>
                    {row?.qty}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(row?.hargaCustom)}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(row?.diskon)}%
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(row?.nilai_diskon)}
                  </TableCell>
                  <TableCell align="right" width="10%">
                    {formatNumber(jumlah)}
                  </TableCell>
                </TableRow>
              )
            })}

          {length > 0 && (
            <TableRow>
              <TableCell colSpan={headCells.length - 1} align="right">
                TOTAL
              </TableCell>
              <TableCell align="right">{formatNumber(total)}</TableCell>
            </TableRow>
          )}
        </FreezeTableClient>
      </div>
    </>
  )
}

const MemoizeTabJasa = React.memo(TabJasa)
export default MemoizeTabJasa

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "doctor_name",
    disablePadding: false,
    label: "DOKTER",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "BANYAK",
    align: "left",
  },
  {
    id: "hargaCustom2",
    disablePadding: false,
    label: "HARGA",
    align: "left",
  },
  {
    id: "diskon",
    disablePadding: false,
    label: "DISKON",
    align: "left",
  },
  {
    id: "nilai_diskon",
    disablePadding: false,
    label: "NILAI DISKON",
    align: "left",
  },
  {
    id: "total",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
  },
]
